import { ResponsiveLine } from "@nivo/line";

const lineGraphSettings = {
  theme: {
    fontSize: `${10}px`,
    textColor: "#8A9099",
    fontFamily: "Poppins",
    fontWeight: "400",
    // legends: {
    //   text: {
    //     fontSize: 8,
    //     fontWeight: "300",
    //   },
    // },
    // ticks: {
    //   text: { fontWeight: "300" },
    // },
  },
};

const LineChart = ({ data, diffOfDays }) => (
  <ResponsiveLine
    data={data}
    isInteractive={true}
    theme={lineGraphSettings.theme}
    colors={"#696AE7"}
    margin={{ top: 10, right: 30, bottom: 40, left: 50 }}
    xScale={{
      type: "time",
      format: "native",
    }}
    enableArea={true}
    // areaBaselineValue={1000}
    xFormat="time:%d %b %Y"
    yScale={{
      type: "linear",
      min: "auto",
      max: "auto",
      stacked: false,
      reverse: false,
    }}
    yFormat=" >-.2f"
    axisTop={null}
    axisRight={null}
    axisBottom={{
      orient: "bottom",
      tickSize: 0,
      tickPadding: 20,
      tickRotation: 0,
      legendOffset: -25,
      format:
        diffOfDays > 0 && diffOfDays < 7
          ? "%a"
          : diffOfDays >= 7 && diffOfDays <= 30
          ? "%b %d"
          : "%b %y",
      tickValues:
        diffOfDays > 0 && diffOfDays < 10
          ? "every day"
          : diffOfDays >= 10 && diffOfDays <= 15
          ? "every 2 day"
          : diffOfDays > 15 && diffOfDays <= 31
          ? "every week"
          : diffOfDays > 700
          ? "every year"
          : "every month",
    }}
    axisLeft={{
      orient: "left",
      tickSize: 0,
      tickValues: 5,
      tickPadding: 20,
      tickRotation: 0,
      legendOffset: -40,
      legendPosition: "middle",
      format: (values) => {
        if (values >= 1000) {
          return `${Math.round(values / 1000)}k`;
        }
        return `${values}`;
      },
    }}
    // areaBaselineValue={0}
    enableGridX={false}
    enablePoints={true}
    enablePointLabel={false}
    gridYValues={4}
    curve="monotoneX"
    // pointSize={10}
    pointSize={10}
    pointColor={"#696AE7"}
    pointBorderColor={"white"}
    pointBorderWidth={3}
    useMesh={true}
    // legends={[
    //     {
    //         anchor: 'center',
    //         direction: 'row',
    //         justify: false,
    //         translateX: 0,
    //         translateY: 160,
    //         itemWidth: 100,
    //         itemHeight: 20,
    //         itemsSpacing: 0,
    //         symbolSize: 8,
    //         symbolShape: CustomSymbolShape,
    //         itemDirection: 'left-to-right',
    //     }
    // ]}
  />
);

export default LineChart;
